/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/media-has-caption */
import React, { FunctionComponent, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Typography } from '@mui/material';
import { AnnotaionDto, LectionSlideDto } from '../../dto/LectionImageDto';
import {
  findAnnotaionsFromId,
  getHeightMegduSlov,
  selectTheme,
} from '../../utils/utils';
import { DialogAnnotation } from '../dialog/DialogAnnotation';
import { LECTION_ROUTE } from '../../constant/routes';
import { DialogCloud } from '../dialog/DialogCloud';

interface Props {
  isOpenOnlyText: boolean;
  curTheme: number;
  realSystemTheme: number;
  selectedId: string;
  slideNum: number;
  fontSize: string;
  dto: LectionSlideDto;
  onClick: (e: any) => void;
}

export const LectionDivTextItem: FunctionComponent<Props> = ({
  isOpenOnlyText,
  curTheme,
  realSystemTheme,
  selectedId,
  slideNum,
  fontSize,
  dto,
  onClick,
}) => {
  const { section, lectionId } = useParams();
  const navigate = useNavigate();
  const [annotationDto, setAnnotationDto] = useState<AnnotaionDto>({
    id: '',
    title: '',
    text: '',
  });
  const [lect, setLect] = useState('');
  const [idMore, setIdMore] = useState('');

  const [openDialog, setOpenDialog] = useState(false);
  const [openDialog2, setOpenDialog2] = useState(false);

  const handleOpenDialog = () => {
    if (isOpenOnlyText) {
      return;
    }
    setOpenDialog(true);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
    navigate(`${LECTION_ROUTE}/${section}/${lectionId}`);
  };

  const handleOpenDialog2 = () => {
    setOpenDialog2(true);
    navigate(`${LECTION_ROUTE}/${section}/${lectionId}`);
  };
  const handleCloseDialog2 = () => {
    setOpenDialog2(false);
    navigate(`${LECTION_ROUTE}/${section}/${lectionId}`);
  };

  const updateImage = (id: string) => {
    onClick(id);
    navigate(`${LECTION_ROUTE}/${section}/${lectionId}`);
  };

  const showPopup = (id: string) => {
    const annotation: AnnotaionDto = findAnnotaionsFromId(id, dto);
    if (annotation.id !== '') {
      setAnnotationDto(annotation);
      handleOpenDialog();
    }
  };

  const showPopup2 = (id: string) => {
    setIdMore(id);
    handleOpenDialog2();
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    let href = window.location.href.substring(
      window.location.href.lastIndexOf('#') + 1
    );

    if (
      !href.includes('update_') &&
      !href.includes('question_') &&
      !href.includes('more_')
    ) {
      if (selectedId !== href) {
        href = selectedId;
      }
      if (
        window.location.href.lastIndexOf('#') > 0 &&
        !window.location.href.includes('empty')
      ) {
        document
          .getElementById(href)
          ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      setLect(
        dto.text
          .replaceAll(
            'linkColor',
            selectTheme(dto.selectTextColor, curTheme, realSystemTheme)
          )
          .replaceAll(
            `id="${href}" style="background-color: undefined;`,
            `id="${href}" style="background-color: ${selectTheme(
              dto.selectBackgroundColor,
              curTheme,
              realSystemTheme
            )};`
          )
          .replaceAll(
            'background-color:#e0e0e0; border: 1px solid #e0e0e0',
            `background-color:${selectTheme(
              dto.backgroundDiv,
              curTheme,
              realSystemTheme
            )}; border: 1px solid ${selectTheme(
              dto.backgroundDiv,
              curTheme,
              realSystemTheme
            )}`
          )
      );
    }

    const element = document.getElementById('box');
    if (element !== null) {
      setTimeout(() => {
        element.scrollIntoView({ behavior: 'auto' });
      }, 100);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [curTheme, selectedId, slideNum]);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    const href = window.location.href.substring(
      window.location.href.lastIndexOf('#') + 1
    );
    if (href.includes('update_')) {
      updateImage(href.replaceAll('update_', ''));
      navigate(
        `${LECTION_ROUTE}/${section}/${lectionId}/#${href.replaceAll(
          'update_',
          ''
        )}`
      );
    }
    if (href.includes('question_')) {
      showPopup(href.replaceAll('question_', ''));
    }
    if (href.includes('more_')) {
      showPopup2(href.replaceAll('more_', ''));
    }
    const element = document.getElementById('box');
    if (element !== null) {
      setTimeout(() => {
        element.scrollIntoView({ behavior: 'auto' });
      }, 100);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.href]);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  }, [slideNum]);

  useEffect(() => {
    setOpenDialog(false);
    setOpenDialog2(false);
  }, []);

  return (
    <div>
      <Typography
        style={{
          fontFamily: 'sans-serif',
          fontSize,
          overflow: 'auto',
          fontWeight: '400',
          textAlign: 'left',
          color: selectTheme(dto.textColor, curTheme, realSystemTheme),
          lineHeight: getHeightMegduSlov(fontSize),
        }}
        component="html"
      >
        <div
          dangerouslySetInnerHTML={{ __html: lect }}
          style={{
            userSelect: 'none',
            WebkitUserSelect: 'none',
          }}
        />
      </Typography>
      <DialogAnnotation
        curTheme={curTheme}
        textColor={dto.textColor}
        backgrounColor={dto.backgroundImage}
        open={openDialog}
        fontSize={fontSize}
        title={annotationDto.title}
        text={annotationDto.text}
        onClose={handleCloseDialog}
      />
      <DialogCloud
        id={idMore}
        curTheme={curTheme}
        textColor={dto.textColor}
        backgrounColor={dto.backgroundText}
        open={openDialog2}
        fontSize={fontSize}
        onClose={handleCloseDialog2}
      />
    </div>
  );
};
